import { Observable, map } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import { mapUser } from '@/utils/user';
import { UserModel } from '@/models';
import ApiBase from './ApiBase';

export default class AdminService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/admin');

  searchUser(searchItems): Observable<UserModel[]> {
    const searchElements = [
      searchItems.firstName ? `fName=${searchItems.firstName}` : '',
      searchItems.lastName ? `lName=${searchItems.lastName}` : '',
      searchItems.email ? `email=${searchItems.email}` : '',
      searchItems.customerId ? `custId=${searchItems.customerId}` : ''
    ].filter((item) => item !== '').join('&');

    return this.api.getJSON(`${AdminService.baseUrl}/searchUser?${searchElements}`).pipe(
      map(this.mapUserList)
    );
  }

  getStoresWithCart(userId) {
    return this.api.getJSON(`${AdminService.baseUrl}/getListOfStoreWithCart?userId=${userId}`);
  }

  getUserCart(userId, storeId) {
    return this.api.getJSON(`${AdminService.baseUrl}/getUserCart?userId=${userId}&storeId=${storeId}`);
  }

  getUserCarts(userId, storesId) {
    // TODO-ELEON: pas de conversion en promesses
    return Promise.all(storesId.map((storeId) => this.getUserCart(userId, storeId).toPromise()
      .then((res) => res))
    );
  }

  updateUserPassword(userId: string, password: string) {
    return this.api.postJSON(`${AdminService.baseUrl}/updateUserPassword`, {
      password,
      userId
    });
  }

  /**
   * Create a customer without password and email
   * @param {string} storeId current storeId
   * @param {object} customer contains infos on customer to create
   * @param {object} creator contains infos on the customer's creator
   * @return {Observable<string>} created customer
   */
  createCustomer(storeId, customer, creator) {
    const payload = {
      customer,
      creator: {
        ...creator,
        _id: creator.userId
      }
    };

    return this.api.postJSON(`${AdminService.baseUrl}/${storeId}/customers/create`, payload);
  }

  updateFreeStorage(userId) {
    return this.api.postJSON(`${AdminService.baseUrl}/updateFreeStorage`, userId);
  }

  // HELPERS

  mapUserList(users): UserModel[] {
    return users.map((user) => mapUser(user));
  }

  createAmountCodePromotion(promo) {
    const payload = {
      ...promo,
      promoCodeCustom: { codePromo: promo.codePromo },
      codePromo: undefined
    };
    return this.api.postJSON(`${AdminService.baseUrl}/promotion/create`, payload);
  }
}
